import '../css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useRef, useState } from 'react';
import NewPage from '../common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeLogId, checkLogin } from '../../store';
import { SyncLoader } from "react-spinners";
import Message from '../common/message';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function LogJackpot() {
    let dark = useSelector((state) => { return state.Darkmode.value });
    let log_id = useSelector((state) => { return state.log_id.value });

    const [search, setSearch] = useState(String(log_id).length > 0 ? String(log_id) : "")
    const [select, setSelect] = useState(false)
    const [selectValue, setSelectValue] = useState("ID")
    const [page, setPage] = useState(1)
    const [totalpage, setTotalPage] = useState(1)
    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })
    const [data, setData] = useState([])

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    const onChangeSearch = (e) => {
        setSearch(e.target.value)
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setPage(1)
            setReload(e => !e)
        }
    };

    useEffect(() => {
        setTimeout(() => {
            dispatch(changeLogId(""))
        }, 100)
    }, [])

    useEffect(() => {
        UpgradeData()
    }, [reload, page])

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/jackpot/history', {
            params: {
                page: page,
                limit: 20,
                sortBy: "",
                order: "",
                userId: search,
                state: "",
                startDate: "",
                endDate: ""
            }
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setData(tmp?.data?.jackpotHistory ?? [])
                setTotalPage(tmp?.data?.total ?? 0)
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };


    let filterData = data

    return (
        <div className='main'>
            <Message message={message} />
            <div className={`main-box ${darkname}`}>
                <div className='member-1'>
                    <div className={`member-2-search ${darkname}`}>
                        <div className={`member-1-select ${darkname}`} onClick={() => setSelect(e => !e)}>
                            <div className={`member-1-select-1 ${darkname}`}>{selectValue}</div>
                            {
                                select
                                    ?
                                    <FontAwesomeIcon icon={faSortUp} />
                                    :
                                    <FontAwesomeIcon icon={faSortDown} />
                            }
                            {
                                select
                                    ? <>
                                        <div className='modal' onClick={() => setSelect(true)}></div>
                                        <div className={`member-1-select-box ${darkname}`}>
                                            <div onClick={() => { setSelectValue(`ID`); setSelect(true) }}>ID</div>
                                        </div>
                                    </>
                                    :
                                    ""
                            }
                        </div>
                        <FontAwesomeIcon icon={faWindowMinimize} className='line' />
                        <div className={`member-2-search-1 ${darkname}`}>
                            <input value={search} onChange={onChangeSearch} placeholder='Search' onKeyDown={handleKeyPress} />
                            <FontAwesomeIcon icon={faMagnifyingGlass} className='member-1-search-ico-3' />
                            {
                                search.length > 0
                                    ?
                                    <FontAwesomeIcon icon={faCircleXmark} className='member-1-search-ico-2' onClick={() => setSearch("")} />
                                    :
                                    ""
                            }
                        </div>
                    </div>
                    <div className={`search-btn ${darkname}`} onClick={() => onSubmitSearch()}>Search</div>
                </div>
                <div className={`member-2 ${darkname}`} style={{ width: "800px" }}>
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "10%", minWidth: "100px" }}>no.</div>
                        <div style={{ width: "10%", minWidth: "180px" }}>로그 날짜</div>
                        <div style={{ width: "10%", minWidth: "120px" }}>유저 아이디</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>로그 유형</div>
                        <div style={{ width: "10%", minWidth: "120px" }}>당첨금</div>
                        {/* <div style={{ width: "10%", minWidth: "120px" }}>당첨시간</div> */}
                        <div>비고</div>
                    </div>
                    <div className='table-body' style={{ minHeight: "600px" }}>
                        {
                            spinner
                                ?
                                <div className='spinner-modal'>
                                    <SyncLoader color="#003577" />
                                </div>
                                :
                                filterData.length === 0
                                    ?
                                    <div className='data-nofound'>
                                        <img src='/img/img_nofound.png'></img>
                                        <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                        <p>NO RECORDS FOUND</p>
                                    </div>
                                    :
                                    <>
                                        {
                                            filterData.map(function (a, i) {
                                                return (
                                                    <MemberItem key={i} item={a} darkname={darkname} dark={dark} />
                                                )
                                            })
                                        }
                                        <NewPage initialData={totalpage} page={page} setPage={setPage} maxFirstPage={20} />
                                    </>

                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, darkname, dark }) {
    // const formatJpTime = (jpTime) => {
    //     let startHour, startMinute, endHour, endMinute;

    //     if (jpTime.length === 4) {
    //         // "1516" 형태 처리 (분 정보가 없는 경우)
    //         startHour = jpTime.substring(0, 2);
    //         endHour = jpTime.substring(2, 4);
    //         startMinute = "00";
    //         endMinute = "00";
    //     } else if (jpTime.length === 8) {
    //         // "15301629" 형태 처리 (분 정보가 있는 경우)
    //         startHour = jpTime.substring(0, 2);
    //         startMinute = jpTime.substring(2, 4);
    //         endHour = jpTime.substring(4, 6);
    //         endMinute = jpTime.substring(6, 8);
    //     } else {
    //         return "Invalid time format";
    //     }

    //     return `${startHour}:${startMinute} ~ ${endHour}:${endMinute}`;
    // };

    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.id}</div>
                <div className='td' style={{ width: "10%", minWidth: "180px" }}>{item.date}</div>
                <div className='right td' style={{ width: "10%", minWidth: "120px" }}>{item.userId}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.state == "Y" ? "당첨" : "미당첨"}</div>
                <div className='right td' style={{ width: "10%", minWidth: "120px" }}>{item.reward}</div>
                {/* <div className='td' style={{ width: "10%", minWidth: "120px" }}>
                </div> */}
                <div className='td'>-</div>
            </div>
        </>
    );
}

export default LogJackpot;